import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { useApi, errMsg } from "@/lib/api";
import { useMe } from "@/context/MeContext";

export const SendSongDialog = ({ media, onClose }) => {
  const api = useApi();
  const { me, refresh } = useMe();
  const [tracks, setTracks] = useState([]);
  const [trackId, setTrackId] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (media && me) api("get", "/me/tracks").then(setTracks).catch(() => setTracks([])); }, [media, me, api]);

  const enough = me && media && me.credits >= media.cost_credits;
  const send = async () => {
    setBusy(true);
    try {
      await api("post", "/submissions", { track_id: trackId, media_id: media.id });
      toast.success(`Canción enviada a ${media.name}. Responderá en máximo 7 días.`);
      refresh();
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!media} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="send-song-dialog" className="border-white/10 bg-[#12121A] text-slate-200">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-white">Enviar a {media?.name}</DialogTitle>
          <DialogDescription className="text-slate-400">
            Cuesta {media?.cost_credits} {media?.cost_credits === 1 ? "crédito" : "créditos"}. Si no responde en 7 días, te devolvemos los créditos.
          </DialogDescription>
        </DialogHeader>
        {tracks.length === 0 ? (
          <p className="text-sm text-slate-400">Todavía no subiste canciones. <Link to="/panel" className="text-[#FF7A45] underline">Sube tu primera canción</Link>.</p>
        ) : (
          <Select value={trackId} onValueChange={setTrackId}>
            <SelectTrigger data-testid="send-song-track-select" className="border-white/10 bg-[#181824]"><SelectValue placeholder="Elige una canción" /></SelectTrigger>
            <SelectContent className="border-white/10 bg-[#181824] text-slate-200">
              {tracks.map((t) => <SelectItem key={t.id} value={t.id}>{t.title}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
        <div className="flex items-center justify-between pt-2">
          <span data-testid="send-song-balance" className="font-mono text-xs text-slate-400">Tu saldo: {me?.credits ?? 0} créditos</span>
          {enough ? (
            <Button data-testid="send-song-confirm-btn" disabled={!trackId || busy} onClick={send} className="rounded-full bg-[#FF4500] text-white hover:bg-[#ff5a1f]">
              {busy ? "Enviando..." : "Confirmar envío"}
            </Button>
          ) : (
            <Link to="/creditos" data-testid="send-song-buy-credits-link" className="rounded-full bg-[#FF4500] px-4 py-2 text-sm font-semibold text-white">Comprar créditos</Link>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
